import { Button, Space } from '@looker/components';
import {
  addDays,
  differenceInCalendarDays,
  endOfDay,
  startOfDay,
} from 'date-fns';

import { ChartType } from '../entities/chart-type';
import type { Filters } from '../entities/filters';

export type EmptyChartStateProps = {
  chartType: ChartType;
  from: Date;
  to: Date;
  filterNoise: boolean;
  onUpdateFilters: (updated: Partial<Filters>) => void;
  compact?: boolean;
};

export function EmptyChartState({
  chartType,
  from,
  to,
  filterNoise,
  onUpdateFilters,
  compact = false,
}: EmptyChartStateProps) {
  function setLastDays(days: number) {
    const now = new Date();
    const nextFrom = startOfDay(addDays(now, -days));
    const nextTo = endOfDay(now);
    onUpdateFilters({ from: nextFrom, to: nextTo });
  }

  function handleDisableNoise() {
    onUpdateFilters({ filterNoise: false });
  }

  return (
    <div
      className="rounded-md border border-gray-200 p-6"
      data-testid="empty-chart-state"
      data-compact={compact ? 'true' : 'false'}
    >
      <div className="text-sm text-gray-600">
        No data found for{' '}
        {compact && (
          <span className="inline-flex items-center rounded bg-primary-100 px-2 py-0.5 font-medium text-primary-600">
            {chartType}
          </span>
        )}
        {compact && ' '}in the selected time range and filters.
      </div>
      {compact ? null : (
        <Space gap="u3" className="mt-3">
          {(() => {
            const currentDays = Math.max(1, differenceInCalendarDays(to, from));
            return (
              <>
                {currentDays < 7 ? (
                  <Button size="small" onClick={() => setLastDays(7)}>
                    Show last 7 days
                  </Button>
                ) : null}
                {currentDays < 30 ? (
                  <Button size="small" onClick={() => setLastDays(30)}>
                    Show last 30 days
                  </Button>
                ) : null}
                {currentDays < 90 ? (
                  <Button size="small" onClick={() => setLastDays(90)}>
                    Show last 90 days
                  </Button>
                ) : null}
              </>
            );
          })()}
          {filterNoise ? (
            <Button size="small" onClick={handleDisableNoise}>
              Disable noise filter
            </Button>
          ) : null}
        </Space>
      )}
    </div>
  );
}
